import * as React from 'react';
import Box from '../../elements/Box';
import Text from '../../elements/Text';
import { TextProps } from '../../elements/Text/Text';
import { useTranslation } from '@front10/utils';
import { StyledProps } from '@front10';

interface Props {
  label?: TextProps;
  from?: TextProps;
  to?: TextProps;
  separator?: TextProps;
  enableRoute?: boolean;
  resultsCount?: number;
  origin: string | undefined;
  destination: string | undefined;
}

export function PaginationDescription({
  label,
  from,
  separator,
  to,
  enableRoute = false,
  resultsCount = 0,
  origin,
  destination,
  ...props
}: StyledProps<Props>) {
  const translate = useTranslation();
  let inputText = '';
  let destinationFrom = '';
  let destinationTo = '';

  if (origin) {
    destinationFrom += origin;
  }
  if (destination) {
    destinationTo += destination;
  }
  if (!enableRoute) {
    inputText = translate(
      'cmp-bus-directory-map-showing-station-count',
      'Showing {0} bus stations in:',
      [resultsCount]
    );
  } else {
    inputText = translate(
      'cmp-bus-directory-map-showing-main-station-pagination',
      'Showing main stations for:'
    );
  }
  return (
    <Box marginLeft="1px" marginBottom="2" textAlign="left" {...props}>
      <Text marginRight="1" fontWeight="bold" {...label}>
        {inputText}
      </Text>
      {origin && (
        <>
          <Text marginRight="1" fontWeight="bold" {...from}>
            {destinationFrom}
          </Text>
        </>
      )}
      {destination && (
        <>
          {enableRoute && (
            <Text marginRight="1" {...separator}>
              {translate('cmp-separator-to', 'to')}
            </Text>
          )}
          <Text fontWeight="bold" {...to}>
            {destinationTo}
          </Text>
        </>
      )}
    </Box>
  );
}
